<template>
  <div class="brand">
    <!-- <transfer :transTitle="transTitle"></transfer> -->
    <tree-transfer
      v-loading="loadBrand"
      :title="transTitle"
      :from_data='fromData'
      :to_data='toData'
      :defaultProps="{label:'name'}"
      @addBtn='add'
      @removeBtn='remove'
      :mode='mode'
      height='540px'
      filter
    >
    </tree-transfer>
    <el-button
      type="primary"
      @click="saveBrand"
    >保存</el-button>
  </div>
</template>
<script>
// import transfer from '@/components/common/transfer'
import treeTransfer from 'el-tree-transfer'
// eslint-disable-next-line
import { getMyBrandList, saveMyBrandList, getMallBrandList } from '@/models/brandModel'
export default {
  name: 'brand',
  components: { treeTransfer },
  data () {
    return {
      transTitle: ['商城品牌', '我的品牌'],
      mode: 'transfer', // transfer addressList
      fromData: [
      ],
      toData: [],
      loadBrand: true,
      toDataIds: ''
    }
  },
  mounted () {
    this.getBrand()
  },
  methods: {
    async getBrand () {
      this.loadBrand = true
      let myBranddata = await getMyBrandList()
      let mallBranddata = await getMallBrandList()
      this.toData = []
      if (myBranddata.length !== 0) {
        for (let i of myBranddata[0].oid.split(',')) {
          this.toData = this.toData.concat(mallBranddata.filter(item => {
            return item.id === i
          }))
          mallBranddata = mallBranddata.filter(item => {
            return item.id !== i
          })
        }
      }
      this.getToDataIds(this.toData)
      setTimeout(() => {
        this.loadBrand = false
      }, 300)
      this.fromData = mallBranddata
    },
    async saveBrand () {
      let params = {
        oid: this.toDataIds
      }
      await saveMyBrandList(params)
      this.getBrand()
    },
    getToDataIds (toData) {
      this.toDataIds = ''
      for (let i of toData) {
        if (this.toDataIds === '') {
          this.toDataIds = i.id
        } else {
          this.toDataIds = this.toDataIds + ',' + i.id
        }
      }
    },
    // 监听穿梭框组件添加
    add (fromData, toData, obj) {
      this.getToDataIds(toData)
    },
    // 监听穿梭框组件移除
    remove (fromData, toData, obj) {
      this.getToDataIds(toData)
    }
  }
}
</script>
<style lang="scss" scoped>
.brand {
  padding: 10px;
  .el-button {
    width: 100px;
    height: 35px;
    margin: 70px 220px;
    line-height: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/basic/brand.vue